export default __webpack_public_path__ + "static/media/tick.e9260eec.svg";